// extracted by mini-css-extract-plugin
module.exports = {"BooleanMark__mark":"jf_a pz_ra pz_nv pz_ro","BooleanMark__mark--yes":"jf_b","BooleanMark__mark--no":"jf_c","BooleanMark__text":"jf_e pz_rf"};